<template>
  <button
    type="button"
    class="btn btn-link"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <Icon class="icon-grow mr-2"/>
    <slot/>
  </button>
</template>

<script>
import Icon from '@primer/octicons/build/svg/question-16.svg'

export default {
  name: 'HelpButton',
  components: {
    Icon,
  },
  inheritAttrs: false,
}
</script>
